import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import { ThemeProvider } from '@material-ui/styles';
import { Grid, FormControl, TextField, MenuItem } from '@material-ui/core';
import { createTheme } from '@mui/material';
import { DefaultSelect } from '../../component/Select';

const theme = createTheme({
  overrides: {
    MuiSelect: {
      nativeInput: {
        color: 'red'
      },
      root: {
        backgroundColor: '#EFF0F6 !important',
        border: '#FF0000',
        borderRadius: '8px',
        boxSizing: 'border-box',
        height: '56px',
        textAlign: 'left'
      }
    },
    MuiTextField: {
      root: {
        '& .MuiInputBase-root': {
          backgroundColor: '#EFF0F6',
          borderRadius: '8px',
          boxSizing: 'border-box',
          height: '56px'
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            backgroundColor: 'white',
            borderColor: '#CAD8FF',
            zIndex: -1
          },
          borderRadius: '10px',
          fontFamily: 'Poppins',
          fontSize: '14px',
          height: '40px',
          zIndex: 1
        },
        '& .small-input': {
          display: 'inline-flex !important',
          width: '45% !important'
        }
      }
    }
  }
});

const countries = ['Georgia', 'USA', 'Ukraine', 'France'];

/// ////////////////////////////////////////////////

const Corporate = () => {
  // const [formValues, setFormValues] = useState({});
  const [companyName, setCompanyName] = useState('');
  const [id, setId] = useState('');
  const [address1, setAddress1] = useState('');
  // const [address2, setAddress2] = useState('');
  const country = 'Georgia';
  const [city, setCity] = useState('');
  const [postal, setPostal] = useState('');
  const [submit, setSubmit] = useState(false);
  const [error, setError] = useState(false);

  const changeCompanyName = (e) => {
    setCompanyName(e.target.value);
  };
  const changeId = (e) => {
    setId(e.target.value);
  };
  const changeAddress1 = (e) => {
    setAddress1(e.target.value);
  };
  // const changeAddress2 = (e) => {
  //   setAddress2(e.target.value);
  // };
  // const changeCountry = (e) => {
  //   setCountry(e.target.value);
  // };
  const changeCity = (e) => {
    setCity(e.target.value);
  };
  const changePostal = (e) => {
    setPostal(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setSubmit(true);
    if (
      companyName.length < 2 ||
      id.length < 11 ||
      address1.length < 2 ||
      city.length < 2 ||
      postal.length < 4 ||
      country.length < 2
    ) {
      setError(true);
    } else {
      setError(false);
      // let obj = {
      //   company: companyName,
      //   id: id,
      //   address1: address1,
      //   address2: address2,
      //   city: city,
      //   postalCode: postal,
      //   country: country,
      // };
      // setFormValues((formValues) => {
      //   console.log("payload: ", { ...formValues, ...obj }); //payload to send to back
      //   return { ...formValues, ...obj };
      // });
    }
  };

  return (
    <FormControl>
      <form
        autoComplete="off"
        noValidate
        onSubmit={onSubmit}
        style={{
          marginBottom: '48px',
          marginTop: '48px',
          width: '384px'
        }}
      >
        <ThemeProvider theme={theme}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                error={!!(submit && companyName.length < 2)}
                fullWidth
                id="outlined-error"
                onChange={changeCompanyName}
                placeholder="Noxtton"
                required
                type="text"
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <InputMask mask="99999999999" maskChar="" onChange={changeId}>
                {() => (
                  <TextField
                    error={!!(submit && id.length < 11)}
                    fullWidth
                    id="outlined-error"
                    placeholder="0123456789"
                    required
                    type="text"
                    variant="outlined"
                  />
                )}
              </InputMask>
            </Grid>

            <Grid item xs={12}>
              <TextField
                error={!!(submit && address1.length < 2)}
                fullWidth
                id="outlined-error"
                onChange={changeAddress1}
                placeholder="E33, Chavchavadze Ave"
                required
                type="text"
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                // onChange={changeAddress2}
                placeholder="Address line 2 (Optional)"
                type="text"
                variant="outlined"
                // onChange={changeAddress2}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                className="small-input"
                error={!!(submit && city.length < 2)}
                id="outlined-error"
                onChange={changeCity}
                placeholder="Tbilisi"
                required
                type="text"
                variant="outlined"
              />
            </Grid>

            <Grid item xs={6}>
              <InputMask mask="9999" maskChar="" onChange={changePostal}>
                {() => (
                  <TextField
                    className="small-input"
                    error={!!(submit && postal.length < 4)}
                    id="outlined-error"
                    placeholder="0179"
                    required
                    type="text"
                    variant="outlined"
                  />
                )}
              </InputMask>
            </Grid>

            <Grid item xs={12}>
              <DefaultSelect
                // eslint-disable-next-line no-console
                onSelect={(value) => console.log(value)}
                // onSelect={(value) => dispatch(setAccount({...userDraft, country: value}))}
                value="Georgia"
              >
                {countries.map((country) => (
                  <MenuItem key={country} value={country}>
                    {country}
                  </MenuItem>
                ))}
              </DefaultSelect>
            </Grid>
          </Grid>

          <div
            style={{
              color: 'red',
              display: error && submit ? 'block' : 'none'
            }}
          >
            Please fill in the required fields
          </div>
        </ThemeProvider>
      </form>
    </FormControl>
  );
};

export default Corporate;
